import { make } from 'redux-chill';

import type { ReceiverInfo } from '../types';

const setDeliveryReceiverInfo = make('[delivery] set receiver info')
  .stage((info: ReceiverInfo) => ({ info }))
  .stage('reset');

export { setDeliveryReceiverInfo };
